module.exports = __webpack_public_path__ + "img/DM-FPD-detail.8022adba.png";